import { EndpointSetting } from "@/constants/app/type";
import { FlightState, TypeSeatMap } from "../type";

export const callbackGetSeatMap: EndpointSetting['caller'] = (
  state: FlightState,
  action: any,
  endpointName: any
) => {
  state.get_seat_map.loading = false
  state.get_seat_map.error = null
  state.get_seat_map.success = true
  const seatMaps = action.payload?.seatMaps || []
  const body = action.meta.arg.body
  const system = `${body.system || ''}`.replace(/^_/, '').toUpperCase()
  const neededExtra = ['VJ', 'VU', 'QH', '9G', 'VN', 'JQ', 'TR', 'GALILEO_NDC'].includes(system)
  for (let i = 0; i < seatMaps.length; i++) {
    const seatMap: TypeSeatMap = seatMaps[i];
    
    state.get_seat_map.data[seatMap.flightNumber] = {
      ...seatMap,
      cabin: seatMap.cabin.map((c: any) => ({
        ...c,
        rows: c.rows.map((r: any) => ({
          ...r,
          seats: r.seats?.map((seat: any) => {
            const extra = neededExtra ? (parseFloat(`${seat.price || 0}`) / 100) * 20 : 0
            const seatAvailabilityStatus = `${seat.seatAvailabilityStatus || ''}`.trim().toUpperCase()
            return {
            ...seat,
            seatAvailabilityStatus,
            extra: extra,
            price: parseFloat(`${seat.price || 0}`) + extra
          }
          })
        }))
      }))
    }
  }
}